import React from 'react';
import { ExternalLink } from 'lucide-react';
import './RSVP.css';

const RSVP = () => {
    return (
        <section id="rsvp" className="section-container">
            <h2 className="section-title">RSVP</h2>
            <div className="rsvp-card text-center" style={{ textAlign: 'center', padding: '3rem 2rem' }}>
                <p className="rsvp-subtitle" style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                    We can't wait to celebrate with you. Please let us know if you can make it!
                </p>
                <a 
                    href="https://withjoy.com/kay-and-vanessa/rsvp" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn btn-elegant"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}
                >
                    Click here to RSVP
                    <ExternalLink size={18} />
                </a>
            </div>
        </section>
    );
};

export default RSVP;
